/**
 * Set up routing for all ModuleCertificate views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import moduleCertificate views
import ModuleCertificateList from './views/ModuleCertificateList.js.jsx';
import SingleModuleCertificate from './views/SingleModuleCertificate.js.jsx';

class ModuleCertificateRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All certificates', path: null}]}
          component={ModuleCertificateList}
          exact
          login={true}
          path="/my-certificates"
        />
        <YTRoute
          breadcrumbs={[{display:'All certificates', path: '/my-certificates'}, {display:'View & Print', path: null}]}
          component={SingleModuleCertificate}
          exact
          login={true}
          path="/my-certificates/:moduleCertificateId"
        />
      </Switch>
    )
  }
}

export default ModuleCertificateRouter;



// WEBPACK FOOTER //
// modules/moduleCertificate/ModuleCertificateRouter.js.jsx